import { SCHEDULE_EVENT_TYPES, SCHEDULE_ANALYTICS_TAB } from 'shared/constants';

/**
 * Consistent property set for the `[Schedule] Report exported` event across all
 * export surfaces (bulk, per-person, per-event, per-event attendees list). Every
 * call emits the same keys so the Mixpanel schema stays uniform; dimensions that
 * don't apply to a given export are explicitly `null` rather than absent.
 *
 * `tab` defaults to Reports (the three reports-tab exports) but is overridable —
 * the per-event attendees export lives on the event detail panel (Events tab).
 */
export function buildReportExportedProps({
  reportType,
  tab = SCHEDULE_ANALYTICS_TAB.REPORTS,
  viewType = null,
  providerId = null,
  eventId = null,
  from = null,
  until = null,
}) {
  return {
    reportType,
    type: SCHEDULE_EVENT_TYPES.EDUCATIONAL,
    tab,
    viewType,
    providerId,
    eventId,
    from,
    until,
  };
}
